// Import Vue
import Vue from "vue";

// FILTERS VUE
Vue.filter("money", (value) => {
  return `R$ ${parseFloat(value).toFixed(2)}`.replace(".", ",");
});

Vue.filter("formatTime", (value) => {
  const timeString = value;

  const time = new Date(`1970-01-01T${timeString}Z`);

  const hours = time.getUTCHours();
  const minutes = time.getUTCMinutes();
  const seconds = time.getUTCSeconds() + time.getUTCMilliseconds() / 1000;

  const result = [hours, minutes, seconds]
    .map(
      (item, index) => `${item}${index === 0 ? "h" : index === 1 ? "m" : "s"}`
    )
    .join(" ");

  return result;
});

Vue.filter("timeFormat", (value) => {
  const timeString = value;

  const time = new Date(`1970-01-01T${timeString}Z`);

  const hours = (time.getUTCHours() <= 9 ? "0" : "") + time.getUTCHours();
  const minutes = (time.getUTCMinutes() <= 9 ? "0" : "") + time.getUTCMinutes();
  const seconds = (
    time.getUTCSeconds() +
    time.getUTCMilliseconds() / 1000
  ).toFixed(0);
  const secondsFormated = (seconds <= 9 ? "0" : "") + seconds;

  const h = parseInt(hours.toString());
  const m = parseInt(minutes.toString());
  const s = parseInt(seconds.toString());

  if (h === 0 && m === 0 && s === 0) {
    return "23:59";
  }

  const result = [hours, minutes, secondsFormated]
    .map((item, index) =>
      parseInt(item) !== 0
        ? `${item}${index === 0 ? "h" : index === 1 ? "m" : "s"}`
        : null
    )
    .filter((item) => item !== null)
    .join(" ");

  return result;
});

Vue.filter("dateTimeFormat", (value) => {
  const dataOriginal = new Date(value);
  const dia = String(dataOriginal.getDate()).padStart(2, "0");
  const mes = String(dataOriginal.getMonth() + 1).padStart(2, "0"); // Mês começa do zero, então somamos 1
  const ano = dataOriginal.getFullYear();
  const dataFormatada = `${dia}/${mes}/${ano}`;

  const hours =
    (dataOriginal.getHours() <= 9 ? "0" : "") + dataOriginal.getHours();
  const minutes =
    (dataOriginal.getMinutes() <= 9 ? "0" : "") + dataOriginal.getMinutes();

  const result = [hours, minutes].join(":");

  return `${dataFormatada} ${result}`;
});
